import { render, staticRenderFns } from "./PageAuthorizationContainer.vue?vue&type=template&id=0c942896&"
import script from "./PageAuthorizationContainer.vue?vue&type=script&lang=js&"
export * from "./PageAuthorizationContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports